/**
 * Created by Анжелика on 13.09.2017.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import moment from 'moment-with-locales-es6';
import PropTypes from 'prop-types';
import * as EpgActions from '../actions/epg';
import * as strings from '../constants/strings';
import EpgDetails from '../components/EpgDetails';

const getCurrentEPG = (epg) => {
    let today = moment().format("YYYY-MM-DD");
    let [k, data] = [...epg].find(([k, v]) => k === today);
    return data && data.items ? data.items.find(item => item.current) : null;
};

class EpgBlock extends Component {

    constructor(props) {
        super(props);
        this.state = {
            inited: false
        }
    }

    componentDidMount() {
        const {activeChannel} = this.props;
        this.initFirstDay(activeChannel);
    }

    componentWillReceiveProps(nextProps) {
        const {activeChannel} = this.props;
        if (nextProps.activeChannel.channelID !== activeChannel.channelID) {
            this.resetDays();
            this.initFirstDay(nextProps.activeChannel);
        }
    }

    initFirstDay(channel) {
        const {epgActions} = this.props;
        epgActions.getNextEPG(channel).then(() => {
            epgActions.startUpdate();
            this.setState({inited: true});
        });
    }

    initMoreDays() {
        const {activeChannel, epgActions} = this.props;
        epgActions.getNextEPG(activeChannel).then(() => {
            this.forceUpdate();
        });
    }

    resetDays() {
        const {epgActions} = this.props;
        this.setState({inited: false});
        epgActions.stopUpdate();
        epgActions.resetDays();
    }

    needInitMoreDays(epg) {
        let firstDayEpg = epg.values().next().value;
        if (firstDayEpg && firstDayEpg.loaded) {
            return [...epg].some(([k, v]) => !v.loaded);
        }
        return false;
    }

    componentWillUnmount() {
        this.resetDays();
    }

    showCurrent() {
        const {current} = this.props;
        return (
            <div className="channel-details-current-program-block">
                {current && <div className="badge">{strings.STR_EPG_CURRENT_NOW_LABEL}</div>}
                {<div className="channel-details-current-program">{current ? current.title : ""}&nbsp;</div>}
            </div>
        )
    }

    render() {
        const {activeChannel, epg, mobileEPGShow, onClose} = this.props;
        let more = this.needInitMoreDays(epg);
        return (
            <div className={"epg-block " + (mobileEPGShow ? "show" : "")}>
                <div className="wrapper">
                    {mobileEPGShow && <div className="epg-close" onClick={onClose}></div>}
                    <div className="channel-info">
                        {activeChannel.image &&
                            <div className="channel-logo">
                                <img src={activeChannel.image} alt=""/>
                            </div>
                        }
                        <div className="channel-details">
                            <div className="channel-details-name">{activeChannel.name}</div>
                            {this.showCurrent()}
                        </div>
                    </div>
                    <hr/>

                    {!this.state.inited ?
                        <div className="loading">{strings.STR_EPG_LOADING}</div>
                        : [...epg].map(([date, value], index) => (
                            (value.loaded || value.error) &&
                                <EpgDetails key={index} date={date} items={value.items} error={value.error} />
                        ))
                    }

                    {this.state.inited && more &&
                        <div className="loading">
                            <a href="" className="btn-link more" onClick={(event) => {event.preventDefault(); event.stopPropagation(); this.initMoreDays()}}>{strings.STR_EPG_MORE}</a>
                        </div>
                    }
                </div>
            </div>
        )
    }
}

EpgBlock.propTypes = {
    activeChannel: PropTypes.object.isRequired,
    epg: PropTypes.object.isRequired,
    epgActions: PropTypes.object.isRequired,
    current: PropTypes.object
};

const mapStateToProps = state => {
    return {
        activeChannel: state.channels.activeChannel,
        epg: state.epg,
        current: getCurrentEPG(state.epg)
    }
};

const mapDispatchToProps = dispatch => {
    return {
        epgActions: bindActionCreators(EpgActions, dispatch)
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EpgBlock);


// WEBPACK FOOTER //
// ./src/containers/EpgBlock.js